module.exports = __webpack_public_path__ + "static/img/map1.c7caed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/map1.png
// module id = wZ5z
// module chunks = 1